import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import BB from './images/BB.png';
import AddUserMale from './images/AddUserMale.png';
import { Msg200or201 } from '../BBAdmin/Messages/Messages';
import Name from './images/Name.png';
import Phone from './images/Phone.png';
import City from './images/City.png';
import Company from './images/Company.png';
import PopupMessage from './Component/PopupMessages';
import { decryptData } from '../utils/storageCrypto';


function AddUserDetails() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [association, setAssociation] = useState('');
  const [firmType, setFirmType] = useState('');
  const [city, setCity] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showFirmTypeDropdown, setShowFirmTypeDropdown] = useState(false);
  const [showAssociationDropdown, setShowAssociationDropdown] = useState(false);
  const firmTypeRef = useRef(null);
  const associationRef = useRef(null);

  // API URLs
  const SaveCustomerURL = process.env.REACT_APP_FORE_BRICKBUCKET + 'customer/create-customer';
  const CustomerLoginURL = process.env.REACT_APP_FORE_BRICKBUCKET + 'customer/verify-customer';

  // Mobile number logic only
  const [mobileNumber, setMobileNumber] = useState('');
  const [isMobileValid, setIsMobileValid] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
  });
const [isMobileExists, setIsMobileExists] = useState(false);
 const showPopup = (type, msg) => { setPopup({ show: true, type, message: msg }); setTimeout(() => setPopup({ show: false, type: "", message: "" }), 2500); };


  const checkMobileExists = async (mobile) => {  
  try {
    const response = await fetch(CustomerLoginURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mobile_number: mobile }),
    });

    const data = await response.json();
    console.log('checkMobileExists response:', data);

    if (response.status === 200) {
      // ❌ Mobile already exists
      setError('This mobile number is already registered. Please login instead.');
      setIsMobileExists(true);
      setIsMobileValid(false);   // 🔒 disable remaining fields
    } 
    else if (response.status === 404) {
      // ✅ Mobile not registered
      setError('');
      setIsMobileExists(false);
      setIsMobileValid(true);    // 🔓 enable remaining fields
    } 
    else {
      setError(data.message || 'Error checking mobile number');
      setIsMobileExists(true);
      setIsMobileValid(false);
    }
  } catch (error) {
    console.error('Error checking mobile number:', error);
    setError('Error checking mobile number. Please try again.');
    setIsMobileExists(true);
    setIsMobileValid(false);
  }
};

  const handleMobileChange = (e) => {
    let value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setMobileNumber(value);
    setError('');

    // First digit validation
    if (value.length >= 1 && !['6', '7', '8', '9'].includes(value[0])) {
      setError("Mobile number must start with 6, 7, 8 or 9");
      setIsMobileValid(false);
      return;
    }

    if (value.length === 10) {
  checkMobileExists(value);
} else {
  setIsMobileValid(false);
  setIsMobileExists(false);
}
    
   
  };

  // Handle login
  const handleLogin = () => {
    navigate('/consumer');
  };

  // Submit registration
  const handleSubmit = async () => {
    // Validate required fields
    if (!name) {
      setError('Name is required');
      return;
    }
    
    if (!mobileNumber || mobileNumber.length !== 10 || !isMobileValid) {
      setError('Valid mobile number is required');
      return;
    }
    
    if (!city) {
      setError('City is required');
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');
    
    try {

     const encryptedLoginData = localStorage.getItem('LoginData');
    
    let token = null;
    let hubId = null;

    if (encryptedLoginData) {
      // Decrypt the whole LoginData block
      const decryptedString = decryptData(encryptedLoginData);
      
      // Parse the string into an object
      const loginInfo = JSON.parse(decryptedString);
      
      // Extract the specific fields needed
      token = loginInfo.token;
      hubId = loginInfo.hubId;
      
      console.log("Extracted Token:", token);
      console.log("Extracted OrgID:", hubId);
    } else {
      console.error("No LoginData found in localStorage");
    }

      const response = await fetch(SaveCustomerURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
           'x-token': token,
        },
        body: JSON.stringify({
          customer_name: name,
          mobile_number: mobileNumber,
          company_name: companyName,
          association: association,
          type_of_firm: firmType,
          city: city,
          hubId: hubId || "default",
          roleId: 5
        }),
      });


      console.log("body sent:", {
        customer_name: name,
        mobile_number: mobileNumber,
        company_name: companyName,
        association: association,
        type_of_firm: firmType,
        city: city,
        hubId: hubId,
        roleId: 5
      });
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Response is not JSON");
      }

      const data = await response.json();
      console.log("API Response:", data);

      if ((response.status === 200 || response.status === 201) && data.success) {
        showPopup("success", "Customer registered successfully!");

        if (data.data) {
          localStorage.setItem('userData', JSON.stringify(data.data));
        }

        setTimeout(() => {
          navigate("/consumer/NotApproved");
        }, 2500);

        return;
      }

      // SERVER ERROR (500)
      if (response.status === 500) {
        showPopup("error", "Server error. Please try again.");
        return;
      }

      // Other backend errors
      showPopup("error", data.message || "Registration failed.");

    } catch (error) {
      console.error("Error:", error);

      if (error.name === "AbortError") {
        showPopup("timeout", "Request timed out.");
      } else {
        showPopup("network", "Unable to connect to the server.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Dropdown click outside handlers
  useEffect(() => {
    function handleClickOutside(event) {
      if (firmTypeRef.current && !firmTypeRef.current.contains(event.target)) {
        setShowFirmTypeDropdown(false);
      }
      if (associationRef.current && !associationRef.current.contains(event.target)) {
        setShowAssociationDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

 useEffect(() => {
  const storedMobile = sessionStorage.getItem('unregisteredMobile');
  if (storedMobile) {
    setMobileNumber(storedMobile);

    // 🔑 IMPORTANT: validate mobile again
    if (storedMobile.length === 10) {
      checkMobileExists(storedMobile);
    }

    sessionStorage.removeItem('unregisteredMobile');
  }
}, []);

  return (
    <div className='flex flex-col items-center w-full'>
      {/* Header */}
      <div className="relative w-full md:w-2/3 h-18 mb-1 mt-4 overflow-hidden border-b border-gray-200 bg-white sticky top-0 z-50">
        <div className="flex w-full h-full items-center justify-between z-10 px-1 mb-2">
          <img src={BB} alt="Brickbucket Logo" className="h-16 w-16 object-contain ml-1" />
          <div className="flex items-center">
            <img src={AddUserMale} alt="Add User" className="h-16 w-16 object-contain mr-3" />
            <div>
              <div className="text-[#00000] text-md font-semibold leading-tight mr-4">Register with</div>
              <div className="text-[#00000] text-xl font-bold leading-tight mr-4">Brickbucket</div>
            </div>
          </div>
        </div>
      </div>

      <div className='flex justify-center items-center w-full px-1 '>
        <div className="flex justify-center items-center w-full">
          <div className="w-full sm:w-full md:w-2/3 bg-opacity-[15%] rounded-sm p-4">
            <h2 className="text-xl font-semibold text-[#00000] mb-4 ml-1">Register</h2>

            {error && (
              <div className="mb-4 px-3 py-2 bg-red-50 border-l-4 border-red-500 text-sm text-red-700 rounded-r flex items-start">
                <svg className="h-4 w-4 text-red-500 mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="mb-4 p-2 bg-green-100 border border-green-400 text-green-700 rounded">
                {success}
              </div>
            )}

            <div className="flex flex-col items-start mt-1 px-1">
              {/* Mobile Number Input */}
              <div className="mb-4 w-full">
                <div className="relative flex items-center w-full">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <span className="text-gray-600 font-medium">+91</span>
                    <div className="h-6 w-px bg-gray-300 mx-3"></div>
                  </div>
                  <input
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    id="mobileNumber"
                    placeholder="Enter Mobile Number"
                    value={mobileNumber}
                    onChange={handleMobileChange}
                    className={`appearance-none border rounded w-full py-4 pl-16 pr-20 text-gray-700 leading-tight focus:outline-none h-12 transition bg-white border-gray-200 focus:border-[#D64541] placeholder-[#A8A1A1] placeholder:text-xs placeholder:font-semibold`}
                    maxLength="10"
                    required
                    autoComplete="off"
                  />
                  
                  {/* Green check for valid mobile */}
                  {isMobileValid && (
                    <span className="absolute right-2 top-1/2 -translate-y-1/2 bg-green-500 rounded-full h-6 w-6 flex items-center justify-center">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                  )}
                </div>
              </div>

              {/* All other fields - Disabled until mobile is valid */}
              <div className={`${!isMobileValid ? 'pointer-events-none select-none' : ''} w-full`}>
                {/* Name Input */}
                <div className="mb-4 w-full">
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-2">
                      <img src={Name} alt="Name" className="h-6 w-8" />
                    </div>
                    <input
                      type="text"
                      id="name"
                      placeholder='Enter your Name'
                      value={name}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/\b\w/g, (char) => char.toUpperCase());
                        setName(value);
                      }}
                      className={`appearance-none border border-gray-200 rounded w-full py-4 pl-14 pr-4 text-gray-700 leading-tight focus:outline-none focus:border-[#D64541] h-12 placeholder-[#A8A1A1] placeholder:text-xs placeholder:font-semibold ${
                        !isMobileValid ? 'bg-[#F0EBEB]' : 'bg-white'
                      }`}
                      style={{ 
                        textTransform: 'none',
                        backgroundColor: !isMobileValid ? '#F0EBEB' : 'white'
                      }}
                      required
                      disabled={!isMobileValid}
                      autoComplete="off"
                    />
                  </div>
                </div>

                {/* City Input */}
                <div className="mb-4 w-full">
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-2">
                      <img src={City} alt="City" className="h-6 w-8" />
                    </div>
                    <input
                      type="text"
                      id="city"
                      placeholder='Enter your city '
                      value={city}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/\b\w/g, (char) => char.toUpperCase());
                        setCity(value);
                      }}
                      className={`appearance-none border border-gray-200 rounded w-full py-4 pl-14 pr-4 text-gray-700 leading-tight focus:outline-none focus:border-[#D64541] h-12 placeholder-[#A8A1A1] placeholder:text-xs placeholder:font-semibold ${
                        !isMobileValid ? 'bg-[#F0EBEB]' : 'bg-white'
                      }`}
                      style={{ textTransform: 'none' }}
                      required
                      disabled={!isMobileValid}
                    />
                  </div>
                </div>

                {/* Company Name Input */}
                <div className="mb-4 w-full">
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-2">
                      <img src={Company} alt="Company" className="h-6 w-8" />
                    </div>
                    <input
                      type="text"
                      id="companyName"
                      placeholder='Enter company name'
                      value={companyName}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/\b\w/g, (char) => char.toUpperCase());
                        setCompanyName(value);
                      }}
                      className={`appearance-none border border-gray-200 rounded w-full py-4 pl-14 pr-4 text-gray-700 leading-tight focus:outline-none focus:border-[#D64541] h-12 placeholder-[#A8A1A1] placeholder:text-xs placeholder:font-semibold ${
                        !isMobileValid ? 'bg-[#F0EBEB]' : 'bg-white'
                      }`}
                      style={{ textTransform: 'none' }}
                      disabled={!isMobileValid}
                    />
                  </div>
                </div>

                {/* Type of Firm - Custom Dropdown */}
                <div className="mb-4 relative w-full" ref={firmTypeRef}>
                  <div
                    className={`border border-gray-200 rounded w-full py-4 px-4 text-gray-700 leading-tight focus:outline-none h-12 flex justify-between items-center cursor-pointer ${
                      !isMobileValid ? 'bg-[#F0EBEB]' : 'bg-white'
                    }`}
                    onClick={() => isMobileValid && setShowFirmTypeDropdown(!showFirmTypeDropdown)}
                  >
                    <span className={firmType ? "text-gray-700" : "text-[#A8A1A1] text-xs font-semibold"}>
                      {firmType || "Type of Firm"}
                    </span>
                    <svg className="fill-current h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                    </svg>
                  </div>
                  
                  {/* Dropdown Menu */}
                  {showFirmTypeDropdown && (
                    <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                      <div
                        className="py-2 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-sm"
                        onClick={() => {
                          setFirmType("Sole Proprietorship");
                          setShowFirmTypeDropdown(false);
                        }}
                      >
                        Sole Proprietorship
                      </div>
                      <div
                        className="py-2 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-sm"
                        onClick={() => {
                          setFirmType("Partnership");
                          setShowFirmTypeDropdown(false);
                        }}
                      >
                        Partnership
                      </div>
                      <div
                        className="py-2 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-sm"
                        onClick={() => {
                          setFirmType("Limited Liability Partnership (LLP)");
                          setShowFirmTypeDropdown(false);
                        }}
                      >
                        Limited Liability Partnership (LLP)
                      </div>
                      <div
                        className="py-2 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-sm"
                        onClick={() => {
                          setFirmType("Private Limited Company");
                          setShowFirmTypeDropdown(false);
                        }}
                      >
                        Private Limited Company
                      </div>
                    </div>
                  )}
                </div>

                {/* Association - Custom Dropdown */}
                <div className="mb-20 relative w-full" ref={associationRef}>
                  <div
                    className={`border border-gray-200 rounded w-full py-4 px-4 text-gray-700 leading-tight focus:outline-none h-12 flex justify-between items-center cursor-pointer ${
                      !isMobileValid ? 'bg-[#F0EBEB]' : 'bg-white'
                    }`}
                    onClick={() => isMobileValid && setShowAssociationDropdown(!showAssociationDropdown)}
                  >
                    <span className={association ? "text-gray-700" : "text-[#A8A1A1] text-xs font-semibold"}>
                      {association || "Association"}
                    </span>
                    <svg className="fill-current h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                    </svg>
                  </div>
                  
                  {/* Dropdown Menu */}
                  {showAssociationDropdown && (
                    <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                      <div
                        className="py-2 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-sm"
                        onClick={() => {
                          setAssociation("naredco");
                          setShowAssociationDropdown(false);
                        }}
                      >
                        NAREDCO
                      </div>
                      <div
                        className="py-2 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-sm"
                        onClick={() => {
                          setAssociation("credai");
                          setShowAssociationDropdown(false);
                        }}
                      >
                        CREDAI
                      </div>
                      <div
                        className="py-2 px-4 hover:bg-gray-50 cursor-pointer text-gray-700 text-sm"
                        onClick={() => {
                          setAssociation("bai");
                          setShowAssociationDropdown(false);
                        }}
                      >
                        BAI
                      </div>
                    </div>
                  )}
                </div>

                {/* Submit Button */}
                <div className={`focus:outline-none flex flex-col justify-center items-center mt-4 w-full bg-white pt-2 border-t border-gray-200`}> 
                  <button
                    className={`rounded-md px-4 mt-2 py-3 w-full font-semibold ${
                      isLoading ? 'opacity-70 cursor-not-allowed' : ''
                    } ${
                      !isMobileValid || isLoading
                        ? 'bg-[#F0EBEB] text-[#A8A1A1] text-sm' 
                        : 'bg-[#D64541] text-white hover:bg-[#D93025]'
                    }`}
                    onClick={handleSubmit}
                    disabled={!isMobileValid || isLoading}
                  >
                    {isLoading ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              </div>

              {/* Login link - Always show */}
          <div className="mt-2 w-full text-center">
  <div className="inline-flex items-center">
    <span className="mr-1 text-[#827E7E] text-sm font-semibold">
      Already have an account?
    </span>
    <button
      onClick={handleLogin}
      className="text-[#D64541] font-semibold hover:underline text-sm"
    >
      Login
    </button>
  </div>
</div>
            </div>
          </div>
        </div>
      </div>

      {/* PopupMessage Component */}
     <PopupMessage
       show={popup.show}
       type={popup.type}
       message={popup.message}
     />
    </div>
  );
}

export default AddUserDetails;
